import { Organization, OrgLocation } from './organization';

// Edit and partial schedule
export class PaySchedule {
  actionType: string;
  locations: CheckModel[];
  systems: CheckModel[];
  payFrequencyDesc: string;
  initialPayPeriodEndDate: Date;
  initialPayDate: Date;
  employerScheduleID: string;
  payScheduleId: number;
  payFrequencyId: number;
  organizationId: number;
  payCount: number;
  contributoryCount: number;
  name: string;
  description: string;
  comments: string;
  isActive: boolean;
  isPartial: boolean;
  fiscalYear: string;
  createdFrom: number;
  createdBy: string;
  createdDatetime: Date;
  modifiedBy: string;
  modifiedDatetime: Date;
  organization: Organization;
  lastPayDate: Date;
  isCurrentFiscalYear: boolean;
  payFrequency: PayFrequency;
  payScheduleEntrys: PayScheduleEntry[];
  selectedPayFrequencyText: string;
  schedPartialFlag: string;
}

export class PayFrequency {
  id: number;
  type: string;
  description: string;
  comments: string;
  createdBy: string;
  createdDatetime: Date;
  modifiedBy: string;
  modifiedDatetime: Date;
  paySchedules: PaySchedule;
}

export class PayScheduleLocations {
  id: number;
  locationCodeId: number;
  payScheduleId: number;
  comments: string;
  isActive: boolean;
  createdBy: string;
  createdDatetime: Date;
  modifiedBy: string;
  modifiedDatetime: Date;

  location: OrgLocation;
  paySchedule: PaySchedule;
}

// multiple select check boxes
export class CheckModel {
  value: string;
  text: string;
  checked: boolean;
}

// Create schedule
export class CreateSchedule {
  isCurrentFiscalYear: boolean;
  lastPayDate: Date;
  locations: Array<CheckModel>;
  systems: Array<CheckModel>;
  payScheduleEntrys: Array<PayScheduleEntry>;
  initialPayPeriodEndDate: Date;
  initialPayDate: Date;
  selectedPayFrequencyText: string;
  SelectedPayFrequencyId: number;
  payCount: number;
  initialContributoryCount: number;
  contributoryCount: number;
  actionType: string;
  fiscalYear: number;
  name: string;
  createdFrom: number;
  organizationId: number;
  organizationName: string;
  isSchedulePartial: boolean;
}

export class PayScheduleEntry {
  id: number;
  payDate: Date;
  payPeriodEndDate: Date;
  isHolidayOrWeekend: boolean;
  holidayOrWeekendName: string;
  isContributory: boolean;
  isSubmitted: boolean;
  isActive: boolean;
  isLocked: boolean;
  remarks: string;
  pdValid: boolean;
}

// Parent component to child component communication
export class ScheduleInput {
  locs: Array<CheckModel>;
  systems: Array<CheckModel>;
  payFrequencies: Array<PayFrequency>;
  orgName: string;
  orgId: number;
  cfy: any;
  nfy: any;
}

// History display in Parent component
export class PayScheduleHistory {
  id: number;
  payScheduleName: string;
  payCount: number;
  contributoryCount: number;
  isPartial: boolean;
  fiscalYear: number;
  createdFrom: number;
  createdBy: string;
  modifiedBy: string;
  partialFlag: number;
  createdDetails: string;
  modifiedDetails: string;
  createdDatetime: string;
  modifiedDatetime: string;
  finalPPED: string;
  comments: string;
  frequency: string;
  systems: string;
  locations: string;
  organizationId: number;
  employerScheduleID: string;
  oldEmpSchId: string;
  actionType: string;
}

